<template>
    <v-app>
    </v-app>
</template>

<script>
    import ApiService from "@/common/api.service";

    export default {
        data() {
            return {
                stripe_data: {}
            }
        },
        mounted() {
            this.stripe_data = {
                state: this.$route.query.state,
                code: this.$route.query.code,
                realmId: this.$route.query.realmId,
                error: this.$route.query.error
            };
            this.finishConnect()
        },
        methods: {
            finishConnect() {
                ApiService.setHeader();
                console.log(this.stripe_data);
                ApiService.get('/quick_books/oauth-redirect', this.stripe_data)
                    .then(response => {
                        this.$router.push('/settings/quickbooks_online');
                    })
                    .catch(error => {
                        this.$router.push('/settings/quickbooks_online');
                    });
            },
        }
    }
</script>

<style scoped>
</style>


